var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"slider-container",style:(_vm.sliderStyle),attrs:{"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.numberShown},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.sliderText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }